<template>
<!-- <v-container>
    <v-layout wrap>
  <v-form v-if="error ==''">
                     <v-text-field
              name="input-10-1"
              label="New Password"
              v-model="password"
              min="8"
              type = "password"
              counter
              :rules="passwordRules"
              required
            ></v-text-field>
                                 <v-text-field
              name="input-10-1"
              label="Re-type new Password"
              v-model="password"
              min="8"
              type = "password"
              counter
              :rules="passwordRules"
              required
            ></v-text-field>

    <v-btn @click="submit">Change Password</v-btn>
  </v-form>
  <div v-else>
      <h1>{{error}}</h1>
  </div>
  </v-layout>
  </v-container> -->







 
  <div xs12 sm10 md4 offset-md3 offset-sm2 style=" width:100%; max-width:100%;" v-bind:class="{'pa-0 ma-0 mt-4 pt-5 background-container-xs' : getScreenWidth() < 900, ' background-container-md' : getScreenWidth() > 900} ">
 

          <v-layout justify-center>
          <v-flex   class="ml-2 mr-2 mt-4" sm8 md4 >
              <v-layout justify-center elevation-2 style="background-color:white;border-radius:2px;">
                  <v-form style="    width: 94%;" v-if="error ==''">

                <v-text-field
              name="input-10-1"
              label="New password"
              type = "password"
              v-model="password"
              :error-messages="passwordErrors"
                  @input="$v.password.$touch()"
                   @blur="$v.password.$touch()"
                  required
            ></v-text-field>

                      <v-text-field
              name="input-10-1"
              label="Retype new password"
              type = "password"
              v-model="repeatPassword"
              :error-messages="repeatPasswordErrors"
                  @input="$v.repeatPassword.$touch()"
                   @blur="$v.repeatPassword.$touch()"
                  required
              
            ></v-text-field>
            <v-layout row justify-center>
                
                 <v-btn class="primary"  @click="submit">
                     Change Password
                 </v-btn>
            </v-layout>
            
            
                  </v-form>

                  <div v-else class="pa-3">
      <h4 class="text-xs-center" style="color:grey;"><i>{{error}}</i></h4>
  </div>
              </v-layout>
          </v-flex>
          </v-layout>





  </div>













</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength, email, sameAs, alpha, numeric } from 'vuelidate/lib/validators'
import axios from "axios";
export default {
  mixins: [validationMixin],
    validations: {
      name: { required, maxLength: maxLength(8) },
      email: { required, email },
      select: { required },
      checkbox: { required },
      password: { required, minLength: minLength(8), alpha, numeric },
      repeatPassword: {required, sameAsPassword: sameAs('password')},
      
    },


  data() {


    return {


      password: "",
      error:'',
      repeatPassword:'',
      errorMessage:"",
      passwordRules: [
        v => !!v || "This field is required.",
        v => v.length <= 8 || "Password should contain more than 8 characters"
      ]
    };
  },
  props: ["token"],
  mounted() {
    window.scrollTo(0, 0);
      this.$store
        .dispatch("recoverChangePasswordGet", this.token)
        .then((response) => {
            if(response.data.error)
            this.error = response.data.error;
        });
  },

  methods: {

    submit() {
      this.$v.$touch();
      this.emailErrors.length == 0 && this.passwordErrors.length == 0 && this.repeatPasswordErrors.length == 0 && this.nameErrors.length == 0 && this.checkboxErrors.length ==0;
     this.register();
    },
    register() {
        this.$store.dispatch("recoverChangePasswordPost",{token:this.token,password:this.password}).then((response) => {
            this.$router.push('/signin')
        })
    },
    getScreenWidth() {
      return screen.width;
      console.log(screen.width);
      console.log(screen.availWidth);
      console.log(screen.systemXDPI);
    }
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
    nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        // !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')
        !this.$v.name.required && errors.push('Username is required.')
        return errors
      },
       checkboxErrors () {
        const errors = []
        if (!this.$v.checkbox.$dirty) return errors
        // !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')
        !this.$v.checkbox.required && errors.push('You have to accept the Terms and Conditions.')
        return errors
      },
      passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength && errors.push("Must be at least 8 characters");
      !this.$v.password.required && errors.push("Password is required");
      this.$v.password.alpha  && errors.push("Should have at least one number");
      this.$v.password.numeric  && errors.push("Should have at least one letter");
      return errors;
    },
    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.repeatPassword.$dirty) return errors;
      !this.$v.repeatPassword.sameAsPassword && errors.push("Must match the first password");
      !this.$v.repeatPassword.required && errors.push("Password is required");
      return errors;
    },
  }
};
</script>


<style scoped>
.terms {
  text-decoration: none;
  outline: none;
  white-space: nowrap;
  color: white !important;
  font-size: 0.75em;
  line-height: 1px;
}

.background-container {
  /* background-image: linear-gradient(to bottom right,#000000,#000000), url(../../assets/login_photo.jpeg); */

  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(../../assets/login_photo.jpeg);
  background-size: 100vw 100vh;
}

.background-container-md {
  padding-top: 10%;
} 

.background-container-xs {
  padding-top: 200px;
} 

</style>



// WEBPACK FOOTER //
// src/components/Common/Reset.vue